import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { NavComponent } from './nav/nav.component';

import { MythingsComponent } from './pages/mythings/mythings.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { RegisterComponent } from './pages/register/register.component';
import { LoginComponent } from './pages/login/login.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { LinkBoxComponent } from './link-box/link-box.component';
import { ContactComponent } from './contact/contact.component';
import { AuthInterceptor } from './auth.interceptor';
import { WebNameComponent } from './pages/web-name/web-name.component';
import { WeblogComponent } from './pages/weblog/weblog.component';
import { TodoComponent } from './pages/todo/todo.component';
import { CookingComponent } from './pages/cooking/cooking.component';
import { BuyComponent } from './pages/buy/buy.component';
import { CommandComponent } from './pages/command/command.component';
import { MusicTextComponent } from './pages/musictext/musictext.component';
import { PostDetailComponent } from './pages/weblog/post-detail/post-detail.component';
import { CommonModule, DatePipe } from '@angular/common';
import { AdminMessagesComponent } from './admin-messages/admin-messages.component';
// import { DatePipe } from '@angular/common';
// import { SwiperModule } from 'swiper/angular';  // ایمپورت این درست است

@NgModule({
  declarations: [
    AppComponent,
    UserInfoComponent,
    HomeComponent,
    NavComponent,
    MythingsComponent,
    GalleryComponent,
    RegisterComponent,
    LoginComponent,
    LinkBoxComponent,
    ContactComponent,
    WebNameComponent,
    WeblogComponent,
    TodoComponent,
    CookingComponent,
    BuyComponent,
    CommandComponent,
    MusicTextComponent,
    PostDetailComponent,
    AdminMessagesComponent
    // CommonModule
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
     HttpClientModule, // Add HttpClientModule to imports
    FormsModule,
    NgImageSliderModule,
    ReactiveFormsModule,
    CommonModule,
    //برای پیام خوش آمد گویی
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
      timeOut: 300,
      progressBar: true,
      closeButton: true,
    }),



  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
